import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Space, Typography } from "antd";
import { doGetCreditBalance } from "stores/slices/auth";

const BulkSMSCreditBalance = ({ apiKey }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [balance, setBalance] = useState(0);

  const getCreditBalanceByApiKey = async () => {
    if (apiKey) {
      const { payload } = await dispatch(
        doGetCreditBalance({ apiKey: apiKey })
      );
      if (payload && payload.status === 200) {
        setBalance(payload?.data > 0 ? payload?.data : 0);
      }
    }
  };

  useEffect(() => {
    getCreditBalanceByApiKey();
  }, [apiKey]);

  return (
    <>
      <div style={styles.creditBalanceContainer}>
        <Space>
          <Typography.Text style={styles.creditBalanceText}>
            {t("text.bulkSMSCreditBalance", {
              balance: balance,
            })}
          </Typography.Text>
        </Space>
      </div>
    </>
  );
};

const styles = {
  creditBalanceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  creditBalanceText: {
    fontSize: 14,
    fontWeight: 500,
  },
};
export default BulkSMSCreditBalance;
